module.exports = {
  language: 'Serbian',
  nationalityKay: 'sr-ba',
  personal: {
    purgePopupContent:
      'Жао нам је, подаци ваше апликације су очишћени због безбедносних политика, можете нас контактирати ако желите да се пријавите ускоро'
  },
  login_maximum: {
    errorContent: 'You have reached maximum login times, please retry the next day.'
  },
  noneSelectedText: 'Молимо изаберите',
  multiselect: {
    deselect: 'Притисните Ентер за уклањање',
    select: 'Притисните Ентер за избор',
    selected: 'Изабрано'
  },
  enter: 'Enter',
  upload_failed: 'Otpremanje nije uspjelo, pokušajte ponovo',
  due_time: 'Pravo vreme',
  requirement: 'Requirement',
  something_went_wrong_please_retry: 'Something went wrong, please retry',
  valid_rediret_home_page_popup_content:
    "Login exception occurred. Are you trying to go to [ {country} - {center} ] homepage to log in? If yes, please click on 'Confirm'; if no, please click 'Cancel' to select again.",
  invalid_rediret_home_page_popup_content: 'Login exception occurred, please select the country and location to proceed.',
  'Temporarily not available': 'Privremeno nije dostupno',
  'Coming soon': 'Uskoro dolazi'
};
